var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',[_c('img',{attrs:{"src":require("../assets/no-data.png"),"width":"150","alt":"暂无数据"}}),_c('p',{staticClass:"light-gray"},[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }